import { NotificationSeverity } from '@/components/notifications/Notification';
import { RouteStatus } from '../enums';
import type {
  AssignDriverRequest,
  AssignDriverResponse,
  ConfirmRouteRequest,
  ConfirmRouteResponse,
} from '../models';

export interface AssignDriverRunnerParams {
  payload: AssignDriverRequest;
  assignDriver: (p: AssignDriverRequest) => Promise<AssignDriverResponse>;
  confirmRoute: (p: ConfirmRouteRequest) => Promise<ConfirmRouteResponse>;
  notify: (message: string, severity: NotificationSeverity) => void;
  getErrorMessage: (err: unknown, fallback: string) => string;
  onSuccess: () => void;
}

const FALLBACK_MESSAGE = 'Error al asignar conductor';
const REASSIGN_FALLBACK_MESSAGE = 'Error al reasignar conductor';

export interface ReassignDriverRunnerParams {
  payload: AssignDriverRequest;
  reassignDriver: (p: AssignDriverRequest) => Promise<AssignDriverResponse>;
  notify: (message: string, severity: NotificationSeverity) => void;
  getErrorMessage: (err: unknown, fallback: string) => string;
  onSuccess: () => void;
}

export async function executeReassignDriver({
  payload,
  reassignDriver,
  notify,
  getErrorMessage,
  onSuccess,
}: ReassignDriverRunnerParams): Promise<void> {
  try {
    await reassignDriver(payload);
    notify('Conductor reasignado', NotificationSeverity.success);
    onSuccess();
  } catch (err) {
    notify(
      getErrorMessage(err, REASSIGN_FALLBACK_MESSAGE),
      NotificationSeverity.error
    );
  }
}

export async function executeAssignDriver({
  payload,
  assignDriver,
  confirmRoute,
  notify,
  getErrorMessage,
  onSuccess,
}: AssignDriverRunnerParams): Promise<void> {
  try {
    const assigned = await assignDriver(payload);

    if (assigned.route?.status !== RouteStatus.PENDING_DRIVER_CONFIRMATION) {
      notify('Conductor asignado', NotificationSeverity.success);
      onSuccess();
      return;
    }

    await confirmRoute({
      routeId: payload.routeId,
      logisticOperatorId: payload.logisticOperatorId,
      driverId: payload.driverId,
    });
    notify('Conductor asignado y ruta confirmada', NotificationSeverity.success);
    onSuccess();
  } catch (err) {
    notify(getErrorMessage(err, FALLBACK_MESSAGE), NotificationSeverity.error);
  }
}
